import { Action, ThunkAction, configureStore } from "@reduxjs/toolkit"
import { profileSlice } from "src/features/profile"
import { appApi } from "./appApi"
import { baseApi } from "./baseApi"

export { useGetClientsQuery } from "./appApi"

export const store = configureStore({
  reducer: {
    [baseApi.reducerPath]: baseApi.reducer,
    [appApi.reducerPath]: appApi.reducer,
    profile: profileSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(baseApi.middleware, appApi.middleware),
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>
